import _ from 'lodash';

export function eventToString(event) {
  if (_.isString(event) || _.isNumber(event)) {
    return event;
  }
  let out = _.get(event, 'target.value', '');
  if (!_.isString(out)) {
    out = '';
  }
  return out;
}

export function eventToNumber(event, isFloat = false) {
  if (event === '') {
    return 0;
  }
  if (_.isString(event)) {
    return isFloat ? parseFloat(event, 10) : parseInt(event, 10);
  }
  if (_.isNumber(event)) {
    return event;
  }
  const out = _.get(event, 'target.value', 0);
  return eventToNumber(out, isFloat);
}

export function eventToObject(event) {
  if (event === '') {
    return null;
  }
  const out = _.get(event, 'target.value', null);
  return out || event;
}

export function eventToBoolean(event) {
  if (event === true || event === false) {
    return event;
  }
  if (_.isString(event)) {
    return parseInt(event, 10);
  }
  if (_.isNumber(event)) {
    return event;
  }
  const out = _.get(event, 'target.value', false);
  return eventToBoolean(out);
}

export function extractEditingTargetPart(store, part = 'model') {
  if (store.state.editingTarget) {
    if (!store.state.queryTabs.has(store.state.editingTarget)) {
      return null;
    }
    const q = store.state.queryTabs.get(store.state.editingTarget);
    return q[part];
  }
  let out = null;
  switch (part) {
    case 'model':
      out = store.state.newQueryModel;
      break;

    case 'media':
      out = store.state.media;
      break;

    default:
  }

  return out;
}

export function eventToType(event, type) {
  let out = event;
  switch (type) {
    case 'string':
      out = eventToString(event);
      break;
    case 'varchar':
      out = eventToString(event);
      break;
    case 'integer':
      out = eventToNumber(event);
      break;
    case 'float':
      out = eventToNumber(event, true);
      break;
    case 'binary':
      out = eventToNumber(event);
      break;
    default:
      out = eventToString(out);
  }
  return out;
}
